import React, { useEffect, useRef, useState } from 'react';
import presenter from "pages/ScheduleCalendar/duck/presenter";
import ShiftApplicantCommentRow from "./ShiftApplicantCommentRow";
import applicantLogic from "pages/ScheduleCalendar/duck/applicantLogic";
import './ShiftApplicantCommentsComponent.scss';
import { isValidObject } from 'helpers/validation';
import { Mixpanel } from 'helpers/Mixpanel';
import { common } from '@material-ui/core/colors';
import displayLogic from 'pages/ScheduleCalendar/duck/displayLogic';

export function ShiftApplicantCommentsComponent({presentedShift, applicant, applicantCommentsDictionary, fecthApplicantPostsDispatch, addApplicantCommentDispatch, allUsers, handleBackButtonClick, applicantId, applicantUserId}) {

    const commentInputRef = useRef(null)

    const [enableSendButton, setEnableSendButton] = useState(false)

    const getRealApplicantID = () => {
        if( isValidObject(applicant) == true ){ return applicant.id }else { return applicantId }
    }

    const realApplicantId = getRealApplicantID() 

    useEffect(() => { 
        fecthApplicantPostsDispatch(realApplicantId); 
        commentInputRef.current.focus();
    }, []);

    const nameAndPosition = presenter.getApplicantNameAndPosition(applicant);
    const tagline = presenter.getApplicantTagline(presentedShift, applicant);
    const sendCommentText = presenter.sendApplicantCommentText();
    const comments = applicantLogic.commentsForApplicant(realApplicantId, applicantCommentsDictionary);
    const shouldShowSingleAvatar = displayLogic.shouldShowOnlyOneAvatarForCommentHeader(presentedShift);

    const commentRows = comments.map((comment) => {
        const userObject = presenter.getUserFromId(comment.owner_id, allUsers);
        return <ShiftApplicantCommentRow key={comment.id} comment={comment} user={userObject} />
    });

    const handleSendComment = (e) => {
        if( commentInputRef.current.value.length == 0 ) { return; }
        addApplicantCommentDispatch(realApplicantId, commentInputRef.current.value);
        commentInputRef.current.value = '';
        Mixpanel.track('Send applicant comment', { applicantId: realApplicantId });
        e.preventDefault();
    }

    const handleInputChange = (e) => {
        setEnableSendButton( commentInputRef.current.value.length > 0 );
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (e.ctrlKey == true || e.shiftKey == true ){
                const oldValue = commentInputRef.current.value;
                const newValue = oldValue + '\n';
                commentInputRef.current.value = newValue;
            }else{
                handleSendComment(e);
            }
        }
    }

    const singleUserToDisplay = presenter.singleUserToDisplay(presentedShift, allUsers, applicant);
    const leftUserToDisplay = presenter.leftUserToDisplay(presentedShift, allUsers);
    const rightUserToDisplay = presenter.rightUserToDisplay(presentedShift, allUsers, applicant);

    return (
        <div className="applicant-comments-container">
            {isValidObject(applicant) == true &&
                <div className="comments-header">
                    { handleBackButtonClick !== null && <img className='back-button' src='/icons/back-chevron.svg' onClick={handleBackButtonClick}></img>} 
                    { shouldShowSingleAvatar==true && <img className='headshot' src={presenter.getUserAvatar(singleUserToDisplay)}/> }
                    { !shouldShowSingleAvatar && <div className='headshot-group'>
                            <img className='left-hs' src={presenter.getUserAvatar(leftUserToDisplay)}/>
                            <img className='right-hs' src={presenter.getUserAvatar(rightUserToDisplay)}/>
                    </div>}

                        <div className='applicant-info'>
                            <label className='name-position'> {nameAndPosition}</label>
                            <label className='tagline'> {tagline} </label>
                        </div>
                </div>}

            <div className={'comments-list ' + (isValidObject(applicant) == false ? 'compact-max-height' : 'regular-max-height')}>
                {commentRows}
            </div>
            <div className="comment-box">
                <textarea ref={commentInputRef} className="comment-input" type='textarea' placeholder={sendCommentText} onChange={handleInputChange} onKeyPress={handleKeyPress}/>
                <img onClick={handleSendComment} className='send-button' src={'icons/' + (enableSendButton == true ? 'blue_send.svg' : 'send.svg') }></img>
            </div>
        </div>
    );
}

export default ShiftApplicantCommentsComponent;